import configuration from '../../../config/configuration';

const isLocalhost = () => {
  const { hostname } = window.location;
  return hostname === 'localhost' || hostname === '127.0.0.1';
};

export const getCookieDomain = () => (isLocalhost() ? '' : configuration.cookie.DOMAIN);

export const buildCookieAttributes = () => {
  const domain = getCookieDomain();
  const domainPart = domain ? `; domain=${domain}` : '';
  return `; path=${configuration.cookie.PATH}${domainPart}`;
};

export const formatCookie = (name, value) => `${name}=${value}${buildCookieAttributes()}`;
